import React from "react";
import PageHero from "../components/PageHero";
import FadeIn from "../components/FadeIn";
import { PARTNERS } from "../mock";
import useSEO from "../hooks/useSEO";

const Partners = () => {
  useSEO({
    title: "Our Partners",
    description: "Prime Trade L.L.C — FZ partners with global producers and logistics providers including Glencore, Bunge, Trafigura, Vitol and Olam.",
  });
  return (
    <main>
      <PageHero title="Our Partners" eyebrow="Partners" breadcrumbs={[{ label: "Partners" }]} />
      <section className="pt-section">
        <div className="max-w-[1280px] mx-auto px-6">
          <FadeIn>
            <div className="max-w-3xl">
              <div className="pt-eyebrow">Companies that care about you</div>
              <h2 className="pt-h2">Trusted by global leaders</h2>
              <div className="pt-divider" />
              <p className="text-[15px] text-[#4a4a4a] leading-relaxed">
                Prime Trade L.L.C — FZ is proud to work alongside a premier network of global partners—from top-tier producers to world-class logistics providers. These strategic alliances are the foundation of our reliable supply chain, ensuring uncompromising quality and the efficient flow of vital commodities worldwide.
              </p>
              <p className="text-[15px] text-[#4a4a4a] leading-relaxed mt-3">We partner with the best to deliver the best.</p>
            </div>
          </FadeIn>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-12">
            {PARTNERS.map((p) => (
              <div key={p.slug} className="pt-partner" style={{ height: 170 }}>
                {p.logo ? <img src={p.logo} alt={p.name} /> : <div className="fallback">{p.name}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Partners;
